import React from "react";
import { useParams } from "react-router-dom";

// @ts-ignore - JSX コンポーネント（型定義なし）
import TitleBlock from "../../../components/block/TitleBlock";
import SvgLoadingAnimation from "../../../components/loading/index";
import Table, { TableColumn } from "../../../components/table/Table";
import { useGetProjectGitHubRepositoriesQuery } from "../../../app/services/github";

const COLUMNS: TableColumn[] = [
  { key: "repository", header: "リポジトリ", minWidth: 220 },
  { key: "branch", header: "デフォルトブランチ", width: 160, minWidth: 120 },
  { key: "access", header: "あなたの権限", width: 140, minWidth: 110 },
];

const ROLE_LABELS: Record<string, string> = {
  viewer: "閲覧",
  editor: "閲覧・書き込み",
  admin: "管理者",
};

/**
 * プロジェクト INFO 内「GitHub」ページ（閲覧のみ）。
 *
 * このプロジェクトに紐付いていて自分が閲覧できる GitHub リポジトリを表示する。
 * 登録・紐付け・権限の設定は管理者が /console/github で行う。
 */
const ProjectGitHubRepositories: React.FC = () => {
  const { projectId } = useParams();
  const { data, isLoading, isError } = useGetProjectGitHubRepositoriesQuery(projectId ?? "", {
    skip: !projectId,
  });
  const repositories = data?.data?.repositories ?? [];

  if (isLoading) return <SvgLoadingAnimation />;

  const message = isError
    ? "リポジトリの取得に失敗しました"
    : repositories.length === 0
      ? "このプロジェクトに紐付いた GitHub リポジトリはありません"
      : null;

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="GitHub"
        description="このプロジェクトで soremon から閲覧・更新できる GitHub リポジトリです。登録と権限の設定は管理者が行います。"
      />
      <Table columns={COLUMNS} minWidth={520}>
        {message ? (
          <tr>
            <td colSpan={COLUMNS.length} className="bodytext-13 u-text-light-gray u-text-center">
              {message}
            </td>
          </tr>
        ) : (
          repositories.map((repository) => (
            <tr key={repository.id}>
              <td className="bodytext-13">
                <a href={repository.html_url} target="_blank" rel="noreferrer" className="u-text-blue">
                  {repository.full_name}
                </a>
              </td>
              <td className="bodytext-13">{repository.default_branch}</td>
              <td className="bodytext-13">{ROLE_LABELS[repository.my_role] ?? repository.my_role}</td>
            </tr>
          ))
        )}
      </Table>
    </div>
  );
};

export default ProjectGitHubRepositories;
